/** Scroll-spy for the sticky summary of the collections index. */
(() => {
  const nav = document.querySelector('[data-bq-spy]');
  if (!nav || !('IntersectionObserver' in window)) return;
  const links = [...nav.querySelectorAll('a[href^="#"]')];
  const parId = new Map(links.map((a) => [a.getAttribute('href').slice(1), a]));
  const io = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        if (!e.isIntersecting) continue;
        links.forEach((l) => l.classList.remove('is-active'));
        parId.get(e.target.id)?.classList.add('is-active');
      }
    },
    { rootMargin: '-22% 0px -66% 0px' }
  );
  parId.forEach((_, id) => {
    const el = document.getElementById(id);
    if (el) io.observe(el);
  });
})();
